<template>
    <div class="svg">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
            <title v-if="title">{{title}}</title>
            <circle :fill="fillColour" cx="12" cy="12" r="7"/>
        </svg>
    </div>
</template>

<script>
    import SvgBase from './SvgBase';
    export default {
        name: 'SvgDot',
        extends: SvgBase
    };
</script>

<style scoped>
    
</style>